import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type { MatterIntakeTemplateResponse } from "@/lib/types";

export interface CreateMatterIntakeTemplateResponseData {
  matterId: string;
  responses: Array<{ templateId: string; questionId: string; answer: string }>;
}

export interface UpdateMatterIntakeTemplateResponseData {
  dateModified: string;
  matterId: string;
  id: string;
  questionId: string;
  answer: string;
}

export interface DeleteMatterIntakeTemplateResponseData {
  id: string;
}

export const createMatterIntakeTemplateResponses = (
  data: CreateMatterIntakeTemplateResponseData,
) =>
  authenticatedFastApiAxiosInstance.post<MatterIntakeTemplateResponse[]>(
    `${baseFastApiMatterRoute}/intake-templates/responses`,
    data,
  );

export const updateMatterIntakeTemplateResponse = (
  data: UpdateMatterIntakeTemplateResponseData,
) =>
  authenticatedFastApiAxiosInstance.patch<MatterIntakeTemplateResponse>(
    `${baseFastApiMatterRoute}/intake-templates/responses`,
    data,
  );

export const deleteMatterIntakeTemplateResponse = ({
  id,
}: DeleteMatterIntakeTemplateResponseData) =>
  authenticatedFastApiAxiosInstance.delete<MatterIntakeTemplateResponse>(
    `${baseFastApiMatterRoute}/intake-templates/responses/${id}`,
  );
